import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { StoreContextProvider } from "../stores/store";
import AppContainer from "./app-container";
import theme from "../stores/theme";
import { MonacoLoader } from "../custom-components/monaco-editor";
import Main from "./app-container-components/app";
import ModuleResultViewer from "./app-container-components/module-result-view";
import ViewAppContainer from "./view-app-container";
import { LoginOIDC } from "./login-oidc";
import { PageContainer } from "./page-container";
import UsersManager from "./app-container-components/administration/manage-users";
import ReportsView from "./app-container-components/reports/reports-table-view";
import Profile from "./app-container-components/profile";
import { CardComponent } from "./app-container-components/card";
import { GetInTouch } from "./app-container-components/contact-us";
import ReportArchivesView from "./app-container-components/reports/report-archives-view";

const App = () => {
  return (
    <MantineProvider withGlobalStyles withNormalizeCSS theme={theme}>
      <MonacoLoader />
      <Notifications zIndex={2000} />
      <StoreContextProvider>
        <Router>
          <PageContainer>
            <Routes>
              {/* <Route path="/" element={<Login />} /> */}
              <Route path="/" element={<LoginOIDC />} />
              <Route
                path="/main/*"
                element={
                  <AppContainer sideMenu>
                    <Main />
                  </AppContainer>
                }
              />
              <Route
                path="/main/"
                element={
                  <AppContainer>
                    <CardComponent />
                  </AppContainer>
                }
              />
              <Route
                path="/view/:parent/:id"
                element={
                  <ViewAppContainer>
                    <ModuleResultViewer />
                  </ViewAppContainer>
                }
              />
              <Route
                index
                path="/users"
                element={
                  <AppContainer>
                    <UsersManager />
                  </AppContainer>
                }
              />
              <Route
                index
                path="/reports/:moduleId"
                element={
                  <AppContainer sideMenu showAll>
                    <ReportsView />
                  </AppContainer>
                }
              />
              <Route
                index
                path="/reportArchives"
                element={
                  <AppContainer>
                    <ReportArchivesView />
                  </AppContainer>
                }
              />
              <Route
                index
                path="/user/:userId"
                element={
                  <AppContainer>
                    <Profile />
                  </AppContainer>
                }
              />
              <Route
                index
                path="/contact-us"
                element={
                  <AppContainer>
                    <GetInTouch />
                  </AppContainer>
                }
              />
            </Routes>
          </PageContainer>
        </Router>
      </StoreContextProvider>
    </MantineProvider>
  );
};
export default App;
